import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "@redux-saga/core";
import rootReducer from "./root.reducer";
import { rootSaga } from "./root.saga";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => 
        getDefaultMiddleware({
            thunk: true,
            serializableCheck: false
        }).concat(sagaMiddleware)
});
sagaMiddleware.run(rootSaga);

export type rootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store;